import React, { useState, useEffect } from "react";
import { Container, Row } from "reactstrap";
import Header from "components/Headers/Header.js";
import { useGetToken } from "lib/api-token";
import {
    useCreatePlan,
    useGetAllPlans,
    useGetActivePlans,
} from "lib/api-plans";
import CreatePlanButton from "components/Plans/CreatePlanButton";
import PlanModal from "components/Plans/PlanModal";
import PlanTable from "components/Plans/PlanTable";

const Plans = () => {
    const [modal, setModal] = useState(false);
    const [formData, setFormData] = useState({
        tokenId: "",
        durationInDays: 30,
        interestRate: 5,
        minInvestment: 100,
        investmentDeadline: "",
        isActive: true,
    });

    const toggle = () => setModal(!modal);

    useEffect(() => {
        if (!modal) {
            setFormData({
                tokenId: "",
                durationInDays: 0,
                interestRate: 0,
                minInvestment: 0,
                investmentDeadline: "",
                isActive: true,
            });
        }
    }, [modal]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : type === "number"
                    ? parseFloat(value) || 0
                    : value,
        }));
    };

    const getTokenQuery = useGetToken();
    const getAllPlansQuery = useGetAllPlans();
    const getActivePlansQuery = useGetActivePlans();
    const {
        mutate: createPlanMutation,
        isLoading,
        error,
        isSuccess,
    } = useCreatePlan({
        onSuccess: (data) => {
            console.log("Plan created successfully:", data);
            setModal(false); 
            getAllPlansQuery.refetch();
            getActivePlansQuery.refetch();
        },
        onError: (error) => {
            console.error("Failed to create plan:", error.message, error);
        },
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        // const selectedToken = getTokenQuery.data?.find(
        //     (token) => token._id === formData.tokenId
        // );
        // console.log(selectedToken, "SELECTED TOKEN");

        const deadline = new Date(formData.investmentDeadline);
        deadline.setHours(23, 59, 59, 0);

        const payload = {
            tokenId: formData.tokenId,
            durationInDays: Math.max(1, parseInt(formData.durationInDays)),
            interestRate: parseFloat(formData.interestRate),
            minInvestment: parseInt(formData.minInvestment),
            investmentDeadline: deadline.toISOString(),
            isActive: formData.isActive,
        };

        console.log("Create Plan Payload:", payload);
        createPlanMutation(payload);
    };

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <Row className="mb-4">
                    <div className="col text-right">
                        <CreatePlanButton
                            onClick={toggle}
                            isLoading={isLoading}
                        />
                    </div>
                </Row>

                <Row>
                    <div className="col">
                        <PlanTable
                            plans={getActivePlansQuery.data}
                            title="Active Staking Plans"
                            isLoading={getActivePlansQuery.isLoading}
                            error={getActivePlansQuery.error}
                            tokens={getTokenQuery.data}
                        />
                    </div>
                </Row>

                <Row>
                    <div className="col">
                        <PlanTable
                            plans={getAllPlansQuery.data}
                            title="All Staking Plans"
                            isLoading={getAllPlansQuery.isLoading}
                            error={getAllPlansQuery.error}
                            tokens={getTokenQuery.data}
                        />
                    </div>
                </Row>

                <PlanModal
                    isOpen={modal}
                    toggle={toggle}
                    formData={formData}
                    handleInputChange={handleInputChange}
                    handleSubmit={handleSubmit}
                    tokens={getTokenQuery.data}
                    isTokenLoading={getTokenQuery.isLoading}
                    tokenError={getTokenQuery.error}
                    isCreating={isLoading}
                    createError={error}
                    isSuccess={isSuccess}
                />
            </Container>
        </>
    );
};

export default Plans;
